export * from './Filter';
export * from './hooks/useFilter';

export type FilterGroupID = string;

export type FilterID = string;

export type FilterGroupDefn = {
    key: FilterGroupID;
    title: string;
    type: 'multiList' | 'nestedMultiList';
    options: FilterDefn[];
};

export type FilterDefn = {
    title: string;
    value: FilterID;
    valueList?: FilterID[];
    displayOnly?: boolean;
    subFilters?: FilterDefn[];
};
